export default "__VITE_ASSET__S99GsJKA__"